import React from "react";
import { Typography } from "antd";
import DefaultParagraph from "./components/DefaultParagraph";
import {
  //Bold,
  DefaultTitle,
} from "./components/ParagraphElement";
const { Title } = Typography;

const PrivacyPolicesThai = () => {
  return (
    <div
      style={{
        margin: "20px auto",
        padding: 10,
      }}
    >
      <Title level={3} style={{ textAlign: "center" }}>
        Privacy Policy
      </Title>
      <div className="w-max m-auto mb-6">
        <DefaultTitle>1. Personal Data which shall be collected</DefaultTitle>
        <DefaultParagraph>
          In general, for the collection of your personal data, ARUN PLUS shall
          collect your personal data by directly requesting the data from you;
          nonetheless, there may be some circumstances that ARUN PLUS collects
          your personal data from other sources such as the company that you are
          positioned in, your employee, secretary or coordinator, government
          authorities or state authorities or other sources of publicly
          disclosed information such as website and searchable data on the
          internet, etc.
        </DefaultParagraph>
        <DefaultParagraph>
          In this regard, ARUN PLUS shall proceed to collect your personal data
          as follows:
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}
        >
          General personal data
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (1) Identity data such as first name, last name, date of birth,
          gender, age, etc.;
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (2) Contact data such as address, phone number, email, emergency
          contract person, social media account, LINE ID, etc.;
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (3) Data of watt-hour meter such as Contract Account number (CA),
          meter serial number (meter ID), etc, for the request of second main
          for the installation of wall-mounted EV Charger,
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (4) Financial data such as bank account number, etc.;
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (5) Records of previous transaction such as time and location of the
          transaction, amount of energy, etc;
        </DefaultParagraph>

        <DefaultTitle>
          2. Purposes for use and process of personal data{" "}
        </DefaultTitle>
        <DefaultParagraph leader="2.1">
          or evaluating, improving and developing ARUN PLUS’s products, services
          and marketing activities;
        </DefaultParagraph>
        <DefaultParagraph leader="2.2">
          For analyzing, researching and developing ARUN PLUS’s products and
          services to respond customer needs;
        </DefaultParagraph>
        <DefaultParagraph leader="2.3" style={{ maxWidth: 760 }}>
          For informing news, promotions, activities invitation of ARUN PLUS
          products and service through E-mails, SMSs and phone calls;
        </DefaultParagraph>
        <DefaultParagraph leader="2.4">
          For operating businesses, payment and accounting activities, and
          management;
        </DefaultParagraph>
        <DefaultParagraph leader="2.5">
          For the request of second main for the installation of residential
          wall-mounted EV Charger;
        </DefaultParagraph>

        <DefaultTitle>3. Period for retention of personal data</DefaultTitle>
        <DefaultParagraph>
          ARUN PLUS shall retain your personal data for the period necessary for
          the purposes of the collection, use or disclosure of personal data set
          out in this Privacy Notice. The criteria for determination of
          retention period are the period necessary for ARUN PLUS to utilize
          your personal data in accordance with the purposes and it shall be
          further retained pursuant to the period necessary for the compliance
          with laws or the statutory prescription period, or for the
          establishment, compliance, exercise or defense of legal claim, or for
          other reasons pursuant to the internal policies and rules in the
          organization of ARUN PLUS.
        </DefaultParagraph>

        <DefaultTitle>4. Disclosure of personal data</DefaultTitle>
        <DefaultParagraph>
          In order to carry out the proceedings for the purposes set out in this
          Privacy Notice, ARUN PLUS may disclose your personal data to the third
          parties as follows:
        </DefaultParagraph>
        <DefaultParagraph leader="4.1">
          Companies in ARUN PLUS Group;
        </DefaultParagraph>
        <DefaultParagraph leader="4.2">
          The government authorities, regulatory authorities, state enterprises,
          state authorities, public organizations, independent organizations
          established under the laws or other authorities as prescribed by laws
          including the officers which exercise powers or perform duties under
          the laws such as court, polices, Revenue Department, the Office of
          Securities and Exchange Commission, Anti-Money Laundering Office,
          Department of Labour Skill Development, Welfare and Labour Protection
          Department, Energy Business Department, Ministry of Natural Resources
          and Environment, Ministry of Transport, Ministry of Energy, Office of
          the Ombudsman, State Audit Office of Thailand, House of
          Representatives Committee, House of Senate Committee, Department of
          Legal Execution, Office of the Attorney General, State Audit Office of
          Thailand, the Office of National Anti-Corruption Commission, National
          Science and Technology Development Agency, etc.;
        </DefaultParagraph>
        <DefaultParagraph leader="4.3">
          Agents, contractors/sub-contractors and/or service providers for any
          operation provided for ARUN PLUS such as professional advisors,
          transportation service providers, the service firms for the conducting
          of marketing activities, travel and accommodation agencies, the
          organizer companies for the convening of activities, trainings or
          seminars, activity organizers, media producers and advertising firms,
          insurers, auditors and legal advisors, landlord of the service
          locations, etc.;
        </DefaultParagraph>
        <DefaultParagraph leader="4.4">
          Management system standards certification institutes;
        </DefaultParagraph>
        <DefaultParagraph leader="4.5">
          Business partners of Arun Plus such as landlord of the service
          locations;
        </DefaultParagraph>
        <DefaultParagraph leader="4.6">
          Shareholders, debenture holders and the representatives of such
          persons;
        </DefaultParagraph>
        <DefaultParagraph leader="4.7">
          Banks or financial institutions;
        </DefaultParagraph>
        <DefaultParagraph leader="4.8">
          The transferee who received the assignment of any right, duty and
          benefit from ARUN PLUS including the person assigned by such
          transferee to proceed on its behalf such as the case of the
          restructuring, merger and acquisition, separation or transfer of
          business, etc.;
        </DefaultParagraph>

        <DefaultTitle>
          5. Your rights as the owner of personal data{" "}
        </DefaultTitle>
        <DefaultParagraph>
          As the owner of personal data, you have the rights as prescribed in
          the Personal Data Protection Act B.E 2562 (2019). In this respect, you
          can request to exercise your relevant rights through the channels
          specified by Arun Plus, whereby you will be entitled to exercise the
          rights when the laws concerning personal data protection are applied
          to ARUN PLUS. In this respect, your relevant rights shall have details
          as follows:
        </DefaultParagraph>
        <DefaultParagraph leader="5.1">
          Right to withdraw consent
        </DefaultParagraph>
        <DefaultParagraph leader="5.1" hideleader>
          In case that ARUN PLUS requests for your consent, you shall have the
          right to withdraw the consent for the Processing of your personal data
          that has already given to ARUN PLUS unless such withdrawal of consent
          is restricted by laws or by the agreement that provides you the
          benefits.
        </DefaultParagraph>
        <DefaultParagraph leader="5.1" hideleader>
          Such withdrawal of consent shall not affect the Processing of personal
          data legally conducted according to your prior consent.
        </DefaultParagraph>
        <DefaultParagraph leader="5.2">
          Right to access to personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.2" hideleader>
          You have the right to request for an access to and the request for the
          copy of your personal data under control of ARUN PLUS, including to
          request ARUN PLUS to disclose the acquisition of such data that you
          have not given consent to ARUN PLUS.
        </DefaultParagraph>
        <DefaultParagraph leader="5.3">
          Right to request for the submission or the transfer of personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.3" hideleader>
          You have the right to request ARUN PLUS to transfer your personal data
          that you have given to ARUN PLUS as prescribed by laws.
        </DefaultParagraph>
        <DefaultParagraph leader="5.4">
          Right to object the collection, use or disclosure of personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.4" hideleader>
          You have the right to object the Processing of data relating to you in
          respect of the collection, use or disclosure of your personal data as
          prescribed by laws.
        </DefaultParagraph>
        <DefaultParagraph leader="5.5">
          Right to request for the erasure of personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.5" hideleader>
          You have the right to request ARUN PLUS to delete your personal data
          as prescribed by laws. Nevertheless, ARUN PLUS may store your personal
          data using electronic system pursuant to which some systems may be
          unable to delete the data, and for such case, ARUN PLUS shall destroy
          or cause such data to be unable to identify your identity.
        </DefaultParagraph>
        <DefaultParagraph leader="5.6">
          Right to request the restriction of the use of personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.6" hideleader>
          You have the right to request ARUN PLUS to restrict the use of your
          personal data as prescribed by laws.
        </DefaultParagraph>
        <DefaultParagraph leader="5.7">
          Right to request for the rectification of personal data
        </DefaultParagraph>
        <DefaultParagraph leader="5.7" hideleader>
          If you found that the data controlled by ARUN PLUS is incorrect or you
          have changed your personal data, you have the right to request ARUN
          PLUS to correct your personal data so that such personal data be
          accurate, current, complete and not causing misunderstanding.
        </DefaultParagraph>
        <DefaultParagraph leader="5.8">
          Right to lodge a complaint
        </DefaultParagraph>
        <DefaultParagraph leader="5.8" hideleader>
          You have the right to lodge a complaint with the competent officers
          under the Personal Data Protection Act B.E 2562 (2019) in case that
          ARUN PLUS breaches or does not comply with such Act.
        </DefaultParagraph>

        <DefaultTitle>6. Amendment of this Privacy Notice </DefaultTitle>
        <DefaultParagraph>
          We may amend and update this Privacy Notice from time to time, and if
          there is such amendment, we will keep you posted through ARUN PLUS
          website and/or inform you via email. If it is necessary to request for
          your consent, we will proceed to request additional consent from you.
        </DefaultParagraph>

        <DefaultTitle>7. Contact channels </DefaultTitle>
        <DefaultParagraph>
          If you have question or require further details concerning the
          protection of your personal data, the collection, use and disclosure
          of your personal data, the exercising of your rights or if you have
          any complaint, you can contact ARUN PLUS as per the following
          channels:
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          Arun Plus Company Limited
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          Contact Place: 555/1, Energy Complex Building A, Floor G, Vibhavadi
          Rangsit Road, Chatuchak District, Chatuchak Sub-district,
          &nbsp;&nbsp;&nbsp;&nbsp;Bangkok 10900
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          Telephone: 02-537-3067
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          Email: onionevcharger@gmail.com
        </DefaultParagraph>
      </div>
    </div>
  );
};

export default PrivacyPolicesThai;
